import {
    FETCH_DASHBOARD_STATS,
    FETCH_DASHBOARD_STATS_SUCCESS,
    FETCH_DASHBOARD_STATS_FAILURE,
} from 'store/actions/types';

const initialState = {
    data: [],
    loading: false,
};

export default function dashboard(state = initialState, action) {
    switch (action.type) {
        case FETCH_DASHBOARD_STATS:
            return Object.assign({}, state, {
                loading: true,
            });
        case FETCH_DASHBOARD_STATS_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                data: Object.assign(state.data, action.response),
            });
        case FETCH_DASHBOARD_STATS_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/dashboardReducer.js